import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "./config/firebase";
import { EmailAuthProvider, getAuth, linkWithCredential } from "firebase/auth";
import { Alert, Button, Form } from "react-bootstrap";
import LoadingScreen from './components/LoadingScreen';
import { doc, getDoc, setDoc } from 'firebase/firestore';

function Register() {

    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const groupID = localStorage.getItem('group');
    const courseID = localStorage.getItem('course');
    const [courseName, setCourseName] = useState(null);
    const [alert, setAlert] = useState({ type: null, message: null });
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (groupID && courseID) {
            const courseRef = doc(db, 'groups', groupID, 'courses', courseID);
            getDoc(courseRef).then((doc) => {
                if (doc.exists()) {
                    setCourseName(doc.data().name);
                }
                setLoading(false);
            });
        }
    }, [groupID, courseID]);

    const registerWithEmailAndPassword = async (firstName, lastName, email, phone, password, groupID, courseID) => {
        try {
            const credential = EmailAuthProvider.credential(email, password);

            const auth = getAuth();
            linkWithCredential(auth.currentUser, credential)
                .then((usercred) => {
                    const user = usercred.user;
                    console.log("Anonymous account successfully upgraded", user);

                    setDoc(doc(db, "users", user.uid), {
                        phone,
                        firstName,
                        lastName,
                        authProvider: "webWidget",
                        courses: [
                            {
                                group: groupID,
                                course: courseID
                            }
                        ]
                    }).then(() => {
                        setAlert({ type: "success", message: "User created successfully!" });
                    });
                }).catch((error) => {
                    console.log("Error upgrading anonymous account", error);
                    if (error.code === 'auth/invalid-email') {
                        setAlert({ type: "danger", message: "The email address is invalid. Please check it and try again." });
                    } else if (error.code === 'auth/email-already-in-use') {
                        setAlert({ type: "danger", message: 'That email is already in use. You can login using the link below, or try another email address.' });
                    } else if (error.code === 'auth/weak-password') {
                        setAlert({ type: "danger", message: 'Please choose a stronger password.' });
                    } else {
                        setAlert({ type: "danger", message: "An error occurred." });
                    }
                });
        } catch (err) {
            console.error(err);
            setAlert({ type: "danger", message: "An error occurred during registration." });
        }
    };

    const register = () => {
        if (!firstName) setAlert({ type: "danger", message: "Please enter a name." });
        registerWithEmailAndPassword(firstName, lastName, email, phone, password, groupID, courseID);
    };

    return (
        <div className="login">
            {loading && <LoadingScreen />}


            {alert.type === "success" &&
                <div className="login__container">
                    <Alert variant="success">Account created successfully!</Alert>
                    <Link className="btn btn-secondary p-1" to="/">Continue</Link>
                </div>
            }

            {alert.type !== "success" &&
                <div className="login__container">

                    <p className="mb-2">Enter your info below to register for <br></br><strong>{courseName}</strong>.<br></br><small className="text-muted text-sm-center d-block mt-2">*All fields are required.</small></p>
                    {alert.type && alert.message && <Alert variant={alert.type}>{alert.message}</Alert>}
                    <Form>

                        <Form.Group className="mb-3" controlId="formName">
                            <div className="container">
                                <div className="row">
                                    <Form.Control className="col me-1" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First Name" />
                                    <Form.Control className="col ms-1" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last Name" />
                                </div></div>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formPhone">
                            <Form.Control value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Mobile Phone Number" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formPassword">
                            <Form.Control value={password} type="password" onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
                        </Form.Group>

                        <div className="d-grid gap-2" >
                            <Button variant="primary" disabled={firstName && lastName && email && phone && password ? false : true} onClick={register}>
                                Register
                            </Button>
                        </div>

                        <Form.Text className="text-muted text-sm-center d-block m-3">
                            Already have an account? <Link to="/">Login</Link> now.
                        </Form.Text>
                    </Form>
                </div>
            }
        </div>
    );
}
export default Register;
